import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <main
          className="main-content"
          style={{
            padding: "48px 20px",
            display: "flex",
            justifyContent: "center",
            minHeight: "60vh",
            alignItems: "center"
          }}
        >
          <div
            style={{
              maxWidth: "540px",
              width: "100%",
              background: "#ffffff",
              borderRadius: "16px",
              padding: "36px 24px",
              boxShadow:
                "0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.05)",
              border: "1px solid #e2e8f0",
              textAlign: "center"
            }}
          >
            <div
              style={{
                width: "60px",
                height: "60px",
                background: "#fee2e2",
                color: "#dc2626",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "30px",
                margin: "0 auto 18px"
              }}
            >
              ⚠️
            </div>
            <h2
              style={{
                fontSize: "1.35rem",
                fontWeight: "700",
                color: "#0f172a",
                marginBottom: "10px"
              }}
            >
              Terjadi Kendala Memuat Halaman
            </h2>
            <p
              style={{
                color: "#475569",
                fontSize: "0.95rem",
                lineHeight: "1.6",
                marginBottom: "24px"
              }}
            >
              Versi sistem baru saja diperbarui atau koneksi internet Anda sempat
              terputus. Silakan muat ulang halaman untuk mendapatkan versi terbaru.
            </p>
            <div
              style={{
                display: "flex",
                gap: "12px",
                justifyContent: "center",
                flexWrap: "wrap"
              }}
            >
              <button
                type="button"
                onClick={this.handleReload}
                style={{
                  background: "#0284c7",
                  color: "#ffffff",
                  border: "none",
                  borderRadius: "8px",
                  padding: "10px 22px",
                  fontSize: "0.95rem",
                  fontWeight: "600",
                  cursor: "pointer",
                  boxShadow: "0 2px 4px rgba(2, 132, 199, 0.2)"
                }}
              >
                🔄 Muat Ulang Halaman
              </button>
              <button
                type="button"
                onClick={this.handleGoHome}
                style={{
                  background: "#f1f5f9",
                  color: "#334155",
                  border: "1px solid #cbd5e1",
                  borderRadius: "8px",
                  padding: "10px 22px",
                  fontSize: "0.95rem",
                  fontWeight: "600",
                  cursor: "pointer"
                }}
              >
                ← Kembali ke Beranda
              </button>
            </div>
          </div>
        </main>
      );
    }

    return this.props.children;
  }
}
